module.exports = __webpack_public_path__ + "img/buy.f775bf15.svg";